// Price type IDs - these should match the IDs in the price_types table
// Database: INSERT INTO price_types (type) VALUES ('fixed'), ('per_person');
// Therefore: ID 1 = 'fixed', ID 2 = 'per_person'
export const PRICE_TYPE_IDS = {
  FIXED: 1, // ID 1 in database
  PER_PERSON: 2, // ID 2 in database
} as const;

// Price type names for display
export const PRICE_TYPE_NAMES = {
  [PRICE_TYPE_IDS.FIXED]: "Fixed",
  [PRICE_TYPE_IDS.PER_PERSON]: "Per Person",
} as const;

// Helper to get price type ID from mode string
export function getPriceTypeId(mode: "fixed" | "per_person"): number {
  return mode === "fixed" ? PRICE_TYPE_IDS.FIXED : PRICE_TYPE_IDS.PER_PERSON;
}

// Helper to get mode string from price type ID
export function getPriceMode(priceTypeId: number): "fixed" | "per_person" {
  return priceTypeId === PRICE_TYPE_IDS.FIXED ? "fixed" : "per_person";
}
